/**
 * Maps the API validation error response details to form errors
 * @param {array} details - Array of details for each field that failed validation
 * @param {messageLookup} messageLookup - Function to lookup a message given the key.
 * @returns {object} Object containing array of error messages for each field
 */
const mapApiErrorsToFieldErrors = (details = [], messageLookup) => {
  return details.reduce((formErrors, detail) => {
    const field = detail.field.replace("#/", "");
    const message = messageLookup(`${field}_${detail.issue}`);

    if (!message) return formErrors;

    if (!formErrors[field]) {
      formErrors[field] = [];
    }

    formErrors[field].push(message);
    return formErrors;
  }, {});
};

/**
 * Provides a message for a given key.  May return undefined if no message mapped.
 * @callback messageLookup
 * @param {string} key - A key composed of field_issue for the form to use for locating a message
 * @returns {string|undefined} - The message to display. Returns undefined if no message located for the key.
 */

export default mapApiErrorsToFieldErrors;
